<h1 mat-dialog-title>{{'dialog.logbook.title' | translate}}</h1>
<mat-dialog-content>
  @if (isAuthor) {
    <div class="pm-logbook-editor">
      <div class="pm-logbook-trumbowyg" [pmTrumbowyg]="trumbowygOptions" [(ngModel)]="newEntry" name="logbook_body" tabindex="0" contenteditable="true"></div>
    </div>
  }
  <div class="entries" #entryList>
    @for (entry of entries; track entry) {
      <pm-logbook-entry [entry]="entry" [isAdmin]="isAdmin" (delete)="onDelete(entry)" (pmLinkClick)="openLink($event)" ></pm-logbook-entry>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (isAuthor) {
    <button mat-button (click)="onAddEntryClick()">{{'dialog.logbook.add' | translate}}</button>
  }
  @if (isAuthor && showLogoutButton) {
    <button mat-button color="primary" (click)="onAddEntryClick(true)">{{'dialog.logbook.add.logout' | translate}}</button>
  }
  <button mat-button [mat-dialog-close]="true">{{'button.close' | translate}}</button>
</mat-dialog-actions>
